import {
  GET_OFFER_DETAILS,
  GET_OFFER_DETAILS_FAILED,
  GET_OFFER_DETAILS_SUCCESS,
  GET_TEMPLATE_DETAILS,
  GET_TEMPLATE_DETAILS_FAILED,
  GET_TEMPLATE_DETAILS_SUCCESS,
  OFFER_COMMON_ERROR,
  OFFER_COMMON_SUCCESS,
  REVOKE_OFFER_LETTER,
  SAVE_OFFER_DETAILS,
  SHOW_OFFER_LETTER,
  SHOW_OFFER_LETTER_FAILED,
  SHOW_OFFER_LETTER_SUCCESS
} from "./actionTypes";

const initialState = {
  loader: false,
  offerDetails: null,
  offerError: null,
  success: null,
  templateData: null,
  showOfferLetterSuccess:null,
  showOfferLetterError:null
};

const OfferReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_OFFER_DETAILS:
      state = {
        ...state,
        loader: true,
        offerDetails: null,
        offerError: null,
      };
      break;
    case GET_OFFER_DETAILS_SUCCESS:
      state = {
        ...state,
        loader: false,
        offerDetails: action.payload,
        offerError: null,
      };
      break;
    case GET_OFFER_DETAILS_FAILED:
      state = {
        ...state,
        loader: false,
        offerDetails: null,
        offerError: action.payload,
      };
      break;
    case SAVE_OFFER_DETAILS:
      state = {
        ...state,
        loader: true,
        success: null,
        offerError: null,
      };
      break;
    case GET_TEMPLATE_DETAILS:
      state = {
        ...state,
        loader: true,
        templateData: null,
        templateLetterTypeError: null,
      };
      break;
    case GET_TEMPLATE_DETAILS_FAILED:
      state = {
        ...state,
        loader: false,
        offerError: action.payload,
        templateData: null,
      };
      break;
    case GET_TEMPLATE_DETAILS_SUCCESS:
      state = {
        ...state,
        loader: false,
        offerError: null,
        templateData: action.payload,
      };
      break;
    case REVOKE_OFFER_LETTER:
      state = {
        ...state,
        loader: true,
        success: null,
        revokeOffererror: null,
      };
      break;
    case OFFER_COMMON_SUCCESS:
      state = {
        ...state,
        loader: false,
        success: action.payload,
        offerError: null,
      };
      break;
    case OFFER_COMMON_ERROR:
      state = {
        ...state,
        loader: false,
        success: null,
        offerError: action.payload,
      };
      break;
      case SHOW_OFFER_LETTER:
        state = {
                                ...state,
                                loader: true,
                                showOfferLetterSuccess:null,
                                showOfferLetterError:null
                }
        break  
         case SHOW_OFFER_LETTER_SUCCESS:
         state = {
                                   ...state,
                                   loader: false,
                                   showOfferLetterSuccess:action.payload,
                                   showOfferLetterError:null
         }
         break     
         case SHOW_OFFER_LETTER_FAILED:
        state = {
                                       ...state,
                                       loader: false,
                                       showOfferLetterSuccess:null,
                                   showOfferLetterError:action.payload
        }
        break 
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default OfferReducer;
